// utils tools
export default {
  components: [
    {
      id: 'addressInput',
      name: 'addressInput',
      label: '填写实物奖品收货地址',
    },
    {
      id: 'addressPicker',
      name: 'addressPicker',
      label: '全国城市级联弹窗',
    },
    // {
    //   id: 'captcha',
    //   name: 'captcha',
    //   label: '滑块验证',
    // },
    {
      id: 'imageResizer',
      name: 'imageResizer',
      label: '裁剪图片',
    },
    {
      id: 'launchApp',
      name: 'launchApp',
      label: '唤起美居APP',
    },
    {
      id: 'signature',
      name: 'signature',
      label: '签名',
    },
    // {
    //   id: 'table',
    //   name: 'table',
    //   label: '分页表格 v1.0.0',
    // },
  ],
}
